import { Type } from '@angular/core';

export const modalRegistry: Record<string, () => Promise<Type<any>>> = {
  AiDescriptionModal: () =>
    import(
      '../components/ai-description-modal/ai-description-modal.component'
    ).then((m) => m.AiDescriptionModalComponent),
  MapRedirectModal: () =>
    import('../../user/map-redirect-modal/map-redirect-modal.component').then(
      (m) => m.MapRedirectModalComponent
    ),
  SubscriptionConfirmationModal: () =>
    import(
      '../../user/user/subscriptions-menu/subscription-confirmation-modal/subscription-confirmation-modal.component'
    ).then((m) => m.SubscriptionConfirmationModalComponent),
  SubscriptionRenewalModal: () =>
    import(
      '../../user/user/subscriptions-menu/subscription-confirmation-modal/subscription-renewal-modal/subscription-renewal-modal.component'
    ).then((m) => m.SubscriptionRenewalModalComponent),
  FavoriteCellPersonalizationModal: () =>
    import(
      '../../map/favorites/favorite-personalization-modal/favorite-personalization-modal.component'
    ).then((m) => m.FavoritePersonalizationModalComponent),
  SetRadiusModal: () =>
    import('../components/set-radius-modal/set-radius-modal.component').then(
      (m) => m.SetRadiusModalComponent
    ),
  WelcomeModal: () =>
    import('../../map/popup-hint/welcome-modal/welcome-modal.component').then(
      (m) => m.WelcomeModalComponent
    ),
  HelpAndFeedbackModal: () =>
    import(
      '../../shared/components/help-and-feedback-modal/help-and-feedback-modal.component'
    ).then((m) => m.HelpAndFeedbackModalComponent),
  SubscriptionPlansModal: () =>
    import(
      '../../shared/components/subscription-plans-modal/subscription-plans-modal.component'
    ).then((m) => m.SubscriptionPlansModalComponent),
};
